import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 9.75c-2.42 0-3.75-1.33-3.75-3.75V3H8Q5 3 5 6v12q0 3 3 3h9q3 0 3-3V9.75zm-3 6h-3.189l.72.72a.75.75 0 0 1-1.06 1.061l-2-2a.75.75 0 0 1-.162-.817.8.8 0 0 1 .162-.244l2-2a.75.75 0 0 1 1.061 1.061l-.72.72H14a.75.75 0 0 1 0 1.499M14.75 6V3.75l4.5 4.5H17c-1.58 0-2.25-.67-2.25-2.25"
    }, null, -1)
  ])))
}
export default { render: render }